var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"z-index":"20000 !important"}},_vm._l((_vm.areas),function(area,index){return _c('SlicedImageLayer',{key:index,attrs:{"bounds":area.bounds,"images":area.images}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }